import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: Infinity,
		},
	},
})
export default queryClient;